import { Chart } from 'react-chartjs-2';

import { Chart as ChartJS, ScriptableContext } from 'chart.js';
import { registerables } from 'chart.js';

import cls from './GaugeChart.module.scss';

ChartJS.register(...registerables);

interface IProps {
  title: string;
  values: {
    percentage: number;
    total: number;
  };
}

export const GaugeChart = ({ title, values }: IProps) => {
  const dataValue = (values.percentage / 100) * 100;
  const remainingValue = 100 - dataValue;

  const data = {
    datasets: [
      {
        data: [dataValue, remainingValue],
        backgroundColor: (context: ScriptableContext<'doughnut'>) => {
          const { chart, dataIndex } = context;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return '#e0e0e0';
          }

          if (dataIndex === 0) {
            const gradient = ctx.createLinearGradient(
              chartArea.left,
              chartArea.top,
              chartArea.right,
              chartArea.bottom
            );
            gradient.addColorStop(0.2, '#3152E7');
            gradient.addColorStop(1, '#FF0000');
            return gradient;
          }

          return '#e0e0e0';
        },
        borderColor: 'transparent',
        circumference: 180,
        rotation: 270,
      },
    ],
  };
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    elements: {
      arc: {
        borderWidth: 0,
      },
    },
    cutout: '80%',
  };

  const customLabelsPlugin = {
    id: 'customLabels',
    beforeDatasetsDraw: (chart: any) => {
      const { ctx, chartArea } = chart;

      if (!chartArea) {
        return;
      }

      const centerX = (chartArea.left + chartArea.right) / 2;
      const centerY = chartArea.top + (chartArea.bottom - chartArea.top) / 1.6;

      const leftX = chartArea.left;
      const rightX = chartArea.right;

      ctx.save();

      ctx.font = 'bold 13px Nunito Sans';
      ctx.fillStyle = '#1A1A1A';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(`${values.percentage}%`, centerX, centerY);

      ctx.font = '13px Nunito Sans';
      ctx.fillStyle = '#5B6076';
      ctx.textAlign = 'left';
      ctx.fillText('0%', leftX, chart.getDatasetMeta(0).data[0].y + 15);

      ctx.font = '13px Nunito Sans';
      ctx.fillStyle = '#319300';
      ctx.textAlign = 'right';
      ctx.fillText('100%', rightX, chart.getDatasetMeta(0).data[0].y + 15);
    },
  };

  return (
    <div>
      <p className={cls['title']}>{title}</p>
      <div className={cls['chart-container']}>
        <Chart
          type="doughnut"
          data={data}
          options={options}
          plugins={[customLabelsPlugin]}
        />
      </div>
      <p className={cls['total-count']}>{values.total}</p>
    </div>
  );
};

export default GaugeChart;
